import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/img/close-icon.svg'


const _hoisted_1 = {
  class: "page-section bg-secondary",
  id: "portfolio"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "portfolio-item" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "portfolio-caption" }
const _hoisted_8 = { class: "portfolio-caption-heading" }
const _hoisted_9 = { class: "portfolio-caption-subheading text-muted" }
const _hoisted_10 = ["id"]
const _hoisted_11 = { class: "modal-dialog" }
const _hoisted_12 = { class: "modal-content" }
const _hoisted_13 = { class: "container" }
const _hoisted_14 = { class: "row justify-content-center" }
const _hoisted_15 = { class: "" }
const _hoisted_16 = { class: "modal-body" }
const _hoisted_17 = { class: "text-uppercase" }
const _hoisted_18 = { class: "item-intro text-muted" }
const _hoisted_19 = ["id"]

import GalleryModal from '@/components/GalleryModal.vue'
import { albums } from '@/data/albums'

export default /*@__PURE__*/_defineComponent({
  __name: 'GallerySection',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text-center" }, [
          _createElementVNode("h2", { class: "section-heading text-uppercase text-white" }, "GALLERY")
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(albums), (album) => {
            return (_openBlock(), _createElementBlock("div", {
              key: album,
              class: "col-lg-4 col-sm-6 mb-4"
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("a", {
                  class: "portfolio-link",
                  "data-bs-toggle": "modal",
                  href: `#portfolioModal${album.id}`
                }, [
                  _cache[0] || (_cache[0] = _createElementVNode("div", { class: "portfolio-hover" }, [
                    _createElementVNode("div", { class: "portfolio-hover-content" }, [
                      _createElementVNode("i", { class: "fas fa-plus fa-3x" })
                    ])
                  ], -1)),
                  _createElementVNode("img", {
                    class: "img-fluid",
                    src: album.image,
                    alt: "..."
                  }, null, 8, _hoisted_6)
                ], 8, _hoisted_5),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(album.heading), 1),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(album.subheading), 1)
                ])
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(albums), (album) => {
      return (_openBlock(), _createElementBlock("div", { key: album }, [
        _createElementVNode("div", {
          class: "portfolio-modal modal fade",
          id: `portfolioModal${album.id}`,
          tabindex: "-1",
          role: "dialog",
          "aria-hidden": "true"
        }, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _cache[3] || (_cache[3] = _createElementVNode("div", {
                class: "close-modal",
                "data-bs-dismiss": "modal"
              }, [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "Close modal"
                })
              ], -1)),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("h2", _hoisted_17, _toDisplayString(album.title), 1),
                      _createElementVNode("p", _hoisted_18, _toDisplayString(album.intro), 1),
                      _createVNode(GalleryModal, {
                        folder: album.id
                      }, null, 8, ["folder"]),
                      _createElementVNode("div", {
                        id: `portfolioModal${album.id}`
                      }, null, 8, _hoisted_19),
                      _cache[2] || (_cache[2] = _createElementVNode("button", {
                        class: "btn btn-primary btn-xl text-uppercase",
                        "data-bs-dismiss": "modal",
                        type: "button"
                      }, [
                        _createElementVNode("i", { class: "fas fa-xmark me-1" }),
                        _createTextVNode(" Close Gallery ")
                      ], -1))
                    ])
                  ])
                ])
              ])
            ])
          ])
        ], 8, _hoisted_10)
      ]))
    }), 128))
  ], 64))
}
}

})